import { render, staticRenderFns } from "./PaymentChargebacks.vue?vue&type=template&id=2ad7505b&"
import script from "./PaymentChargebacks.vue?vue&type=script&lang=js&"
export * from "./PaymentChargebacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports